import { http, UploadHttp } from './base'
// import { cookie } from '@/utils'

// const headers = { 'x-token': cookie.get('x-token') }
// console.log(headers)

const getList = (params) => {
  return http.get('delivery/getDeliveryMark', params
  )
}

const submit = (params) => {
  return http.post('delivery/postDelivery', params)
}

const upload = (params) => {
  return UploadHttp.post('applyUploadToken/jfiles_hero_weibo', params)
}

const addDraft = (params) => {
  return http.post('drafts/save', params)
}

const getDraft = (params) => {
  return http.get('drafts', params)
}

const deleteDraft = () => {
  return http.post('drafts/delete')
}

export default {
  getList,
  upload,
  submit,
  addDraft,
  getDraft,
  deleteDraft
}
